import { rando } from '../../lib/rando-sidecar'
import { common } from '../../main/common-sidecar'
import { EVoyageCrewType } from './voyageCrew'
import { voyageCrew } from './voyageCrew-sidecar'
import { voyageGameStatus } from './voyageGameStatus-sidecar'
import { voyageGameStatus_enemyShips } from './voyageGameStatus_enemyShips-sidecar'
import { voyageParticles } from './voyageParticles-sidecar'
import { voyageSounds } from './voyageSounds-sidecar'
import { voyageTestParams } from './voyageTestParams-sidecar'
import { voyageTilemap } from './voyageTilemap-sidecar'

let _directorTimer = 0
let _directorTime = 30

let _superTestMode = false && voyageTestParams.isDevMode
let _events = ['boarded', 'fire', 'ship', 'nothing', 'hull-breach']
if (_superTestMode) {
  _directorTime = 3
  _directorTimer = 1000
  _events = ['boarded']
}

export function* generator_director(): Generator<number, number, number> {
  voyageGameStatus.get().isGameStarted = true

  while (true) {
    let ds = common.getUpdateDeltaScaled()
    _directorTimer += ds

    console.log(_directorTimer, _directorTime)

    if (_directorTimer > _directorTime) {
      _directorTimer = 0

      // let events = ['boarded']

      let event = rando.sample(_events)
      console.log('EVENT', event)

      if (event === 'fire') {
        // let fl = voyageTilemap.getRandomFloor()
        // let fire = voyageCrew.create(EVoyageCrewType.Fire, -1)
        // voyageCrew.moveToIJ(fire, fl)

        voyageGameStatus_enemyShips.hitByWeapon(0.9, 100, 0, false)
      }

      if (event === 'hull-breach') {
        voyageGameStatus_enemyShips.hitByWeapon(0.9, 0, 100)

        // let fl = voyageTilemap.getRandomFloor()
        // let breach = voyageCrew.create(EVoyageCrewType.HullBreach, -1)
        // voyageCrew.moveToIJ(breach, fl)
      }

      if (event === 'ship') {
        voyageGameStatus_enemyShips.createHammerheadClass()
      }
      if (event === 'boarded') {
        let num = rando.i(1, 5)

        for (let i = 0; i < num; i++) {
          setTimeout(() => {
            let fl = voyageTilemap.getRandomFloor()
            let alien = voyageCrew.create(EVoyageCrewType.Alien, 1)
            voyageCrew.moveToIJ(alien, fl)
            voyageSounds.playTeleport()
            voyageParticles.createMultiple('teleport', fl.x, fl.y + 16, 18)
          }, 1000 * i)

          // let entrance = voyageTilemap.getRandomLanding()
          // voyageCrew.moveToIJ()
        }
      }
    }
    yield 0
  }
}
